module.exports = __webpack_public_path__ + "static/media/SubscribedDocuments.2ed0803f.svg";